import { useMemo, useRef } from "react"

const sameItems = (a, b) => a && b && a.length === b.length && a.every((item, index) => item === b[index])

const byStart = (a, b) =>
  (a.starts_at || "").localeCompare(b.starts_at || "") || String(a.id).localeCompare(String(b.id))

// An unchanged cell keeps the very same array, so its memoized component skips render.
const useCellIndex = (assignments, rowKeyOf) => {
  const previous = useRef(new Map())

  return useMemo(() => {
    const next = new Map()
    assignments.forEach(item => {
      const key = `${rowKeyOf(item)}|${item.date}`
      if (!next.has(key)) next.set(key, [])
      next.get(key).push(item)
    })
    next.forEach((items, key) => {
      items.sort(byStart)
      const before = previous.current.get(key)
      if (sameItems(before, items)) next.set(key, before)
    })
    previous.current = next
    return next
  }, [assignments, rowKeyOf])
}

export const EMPTY = Object.freeze([])

export default useCellIndex
